import React from 'react'
import { Theme } from 'features/ui/types'
import styled from 'styled-components'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import {
  StyledHeaderContainer,
  StyledContainer,
  StyledContentContainer,
  StyledHeaderRight,
  StyledIconContainer,
  StyledContent,
  StyledActionContainer,
  StyledMetadataContainer
} from './index.css'

const StyledNoHeaderContent = styled(StyledContent)`
  flex-grow: 1;
`

const DateTimeContainer = styled(StyledHeaderRight)`
  min-width: fit-content;
`

type VocSoundbiteNoHeaderFrameProps = {
  dateItem: React.ReactNode
  domainIcon: React.ReactElement
  internalContents: React.ReactNode
  actionItems: React.ReactNode
  metadataItems: React.ReactNode
  mediaItems: React.ReactNode
  avatar: React.ReactNode
  serialNumber: number
  onClick?: (content: any) => void
}

const VocSoundbiteNoHeaderFrame = ({
  dateItem,
  domainIcon,
  internalContents,
  actionItems,
  metadataItems,
  mediaItems,
  avatar,
  serialNumber,
  onClick
}: VocSoundbiteNoHeaderFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.soundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer onClick={onClick}>
        <StyledHeaderContainer>
          <StyledNoHeaderContent mode={theme}>{internalContents}</StyledNoHeaderContent>
          <DateTimeContainer mode={theme}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </DateTimeContainer>
        </StyledHeaderContainer>
        {actionItems && <StyledActionContainer>{actionItems}</StyledActionContainer>}
        {mediaItems}
        <StyledMetadataContainer mode={theme}>{metadataItems}</StyledMetadataContainer>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default VocSoundbiteNoHeaderFrame
